import React from "react";
import "../css/custom.css";

const Divider = () => (
  <div className="divider-container">
    <hr className="divider" />
  </div>
);

export default Divider;
